import { Component, OnInit, ViewChild } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModuloAyudaService } from './modulo-ayuda.service';
import { TipoSolicitudEntry } from 'src/app/shared/entrys/tipo-solicitud.entry';
import { ModalGenerarAyudaComponent } from 'src/app/components/core/layouts/modal-generar-ayuda/modal-generar-ayuda.component';
import { EstadosRNTEntry } from 'src/app/shared/entrys/estados-rnt-entry';
import { EstadoSolicitudEntry } from 'src/app/shared/entrys/estado-solicitud.entry';
import { EstadoRnt } from 'src/app/shared/entrys/estado-contador-establecimiento.entry';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';
import { SubCategoriaEntry } from 'src/app/shared/entrys/sub-categoria.entry';
import { MatOption } from '@angular/material/core';

@Component({
	selector: 'app-modulo-ayuda',
	templateUrl: './modulo-ayuda.component.html',
	styleUrls: ['./modulo-ayuda.component.scss'],
})
export class ModuloAyudaComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerModuloAyuda: Array<string>;
	formModuloAyuda: FormGroup;
	selectModuloAyuda: any;

	paginaActual: number;
	// filtros
	filtro: FormGroup;
	tipos_rnt: Array<any> = [];
	estado_rnt: Array<EstadosRNTEntry> = [];
	tipo_solicitud: Array<TipoSolicitudEntry> = [];
	estado_solicitud: Array<EstadoSolicitudEntry> = [];
	sub_categoria: Array<SubCategoriaEntry> = [];

	public isCollapsed = true;
	@ViewChild('allSelected') private allSelected: MatOption;
	constructor(private formBuilder: FormBuilder, private moduloAyudaService: ModuloAyudaService, private modalService: NgbModal) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;
		this.createForm();

		this.selectModuloAyuda = null;
		this.paginaActual = 1;

	}

	ngOnInit() {
		this.headerModuloAyuda = ['Tipo RNT', 'Estado RNT','Subcategorías', 'Identificador Interfaz',
			'Tipo Solicitud', 'Estado Solicitud', 'Texto Ayuda', 'Estado', 'Acción'];
		this.consultarLista();
		this.onConsultarModuloAyuda(1);
	}

	createForm() {
		this.formModuloAyuda = this.formBuilder.group({
			tipo_rnt_id: [null],
			estado_rnt_id: [null],
			subcategorias_ids:[null],
			identificador_interfaz: [null, Validators.required],
			tipo_solicitud_id: [null],
			texto_ayuda: [null, Validators.required],
			estado_solicitud_id: [null],
			activo: [null]
		});

		this.filtro = this.formBuilder.group({
			tipo_rnt_id: [null],
			estado_rnt_id: [null],
			identificador_interfaz: [null],
			tipo_solicitud_id: [null],
			sub_categoria_id :[null],
			estado_solicitud_id: [null],
			activo: [null]
		});
	}

	onConsultarModuloAyuda(page: number) {
		this.moduloAyudaService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarModuloAyuda(value);
	}

	onAgregarModuloAyuda() {
		let formValue = {...this.formModuloAyuda.value};
		formValue.subcategorias_ids=(formValue.subcategorias_ids != null)?formValue.subcategorias_ids.join(','):'';
		
		this.moduloAyudaService.create(formValue)
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarModuloAyuda(this.paginaActual);
					this.formModuloAyuda.reset();
				}
			});
	}

	onOpenModalGenerarAyuda(ayuda = { texto_ayuda: null }) {
		const modalRef = this.modalService.open(ModalGenerarAyudaComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop', windowClass: 'modal-customer-xl', backdrop: 'static' });
		modalRef.componentInstance.texto_ayuda = ayuda.texto_ayuda || this.formModuloAyuda.value.texto_ayuda;
		if (ayuda.texto_ayuda) {
			modalRef.componentInstance.editable = false;
		}
		modalRef.result.then(resultado => {
			if (!ayuda.texto_ayuda) {
				this.formModuloAyuda.get('texto_ayuda').patchValue(resultado);
			}
		});
	}

	onOperarModuloAyuda() {
		if (!this.selectModuloAyuda) {
			this.onAgregarModuloAyuda();
		} else {
			this.onModificarModuloAyuda();
		}
	}

	onCargarModuloAyuda(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
		if(entry.subcategorias_ids != null){
			entry.subcategorias_ids=entry.subcategorias_ids.map(i=>Number(i));
		}
		
		this.formModuloAyuda.patchValue({
			...entry,
		});
		this.formModuloAyuda.get('activo').setValidators(Validators.required);
		this.selectModuloAyuda = entry;
	}

	onEliminarModuloAyuda(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.moduloAyudaService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items.map(e => e.ayuda_interfaz_id).indexOf(entry.ayuda_interfaz_id);
					this.dataTabla.items.splice(index, 1);
					this.selectModuloAyuda = null;
					this.formModuloAyuda.reset();
				}
			});
		});
	}

	onModificarModuloAyuda() {
		let formValue = {...this.formModuloAyuda.value};
		formValue.subcategorias_ids=(formValue.subcategorias_ids != null)?formValue.subcategorias_ids.join(','):'';
		
		
		this.moduloAyudaService.update({
			...this.selectModuloAyuda,
			...formValue
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarModuloAyuda(this.paginaActual);
					this.formModuloAyuda.get('activo').clearValidators();
					this.formModuloAyuda.reset();
					this.selectModuloAyuda = null;
				}
			});
	}

	consultarLista() {
		this.moduloAyudaService.getTipoRnt().subscribe(resultado => {
			if (resultado.result) {
				this.tipos_rnt = resultado.data;
			}
		});
		this.moduloAyudaService.getTipoSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.tipo_solicitud = resultado.data;
			}
		});
		this.moduloAyudaService.getEstadoSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.estado_solicitud = resultado.data;
			}
		});
		this.moduloAyudaService.getEstadosRNT().subscribe(resultado => {
			if (resultado.result) {
				this.estado_rnt = resultado.data;
			}
		});
		this.moduloAyudaService.getSubcategorias().subscribe(resultado => {
			if(resultado.result){
				this.sub_categoria = resultado.data;
			}	
		})
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarModuloAyuda(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiarModuloAyuda() {
		this.formModuloAyuda.reset();
		this.selectModuloAyuda = null;
		this.createForm();
	}
	subCategoriasToString(items: any[]){
		return items.map( o => o.descripcion );
	}
	toggleAllSelection() {
		if (this.allSelected.selected) {
		  this.formModuloAyuda.controls.subcategorias_ids
			.patchValue([...this.sub_categoria.map(item => item.sub_categoria_id), 0]);
		} else {
		  this.formModuloAyuda.controls.subcategorias_ids.patchValue([]);
		}
	}
}
